<template>
  <div>
    <link
      :href="fontUrl"
      rel="stylesheet"
    >
    <kf-wc-child-benefit-calculator />
  </div>
</template>

<script>
import { trackEvent } from '@/lib/gtm/trackEvent';


export default {
  name: 'KfCalculationTool',
  props: {
    fontUrl: {
      type: String,
      default: 'https://s3.eu-de.cloud-object-storage.appdomain.cloud/whyplan-frontend-prod/guardian/styles/fonts.css',
    },
    scriptUrl: {
      type: String,
      default: 'https://s3.eu-de.cloud-object-storage.appdomain.cloud/whyplan-frontend-prod/webcomponents/guardian/kf-wc.js'
    }
  },

  created() {
    let yourScript= document.createElement('script');
    yourScript.setAttribute('src', this.scriptUrl);
    document.head.appendChild(yourScript);

    this.$nextTick(() => {
      trackEvent({
      event: 'start_calculation',
      event_name: 'start_calculation',
      event_category: 'calculation',
      event_action: 'start_calculation'
      },
      this.$gtm.enabled())
    })
  },

};
</script>
